// @ts-nocheck
import React from 'react';
import { driverApi } from './../../lib/api';
import AutocompleteSelect from './AutocompleteSelect';
import { convertEmployeeToString } from '../../lib/helpers';
export default selectProps => <AutocompleteSelect fetch={selectProps.driverWithUsers ? driverApi.driversWithUsers : driverApi.fetchDrivers} fetchSingle={driverApi.fetchDriver} notFoundText="Водители не найдены" placeholder="Выберите водителя" renderOption={(driver, Option) => <Option key={driver.id} value={driver.id} driver={driver}>
        {convertEmployeeToString(driver.employee)}
      </Option>} {...selectProps} />;
